import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel, Button } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';
import { BsTrash } from 'react-icons/bs';

interface CommunityFormProps {
    ticket_group_code: string;
    items: Item[];
    button_name: string[][];
    url: string[][];
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onButtonNameChange: (e: React.ChangeEvent<HTMLInputElement>, ticketIndex: number, btnIndex: number) => void;
    onUrlChange: (e: React.ChangeEvent<HTMLInputElement>, ticketIndex: number, btnIndex: number) => void;
    onAddMore: (ticketIndex: number) => void;
    onDelete: (ticketIndex: number, btnIndex: number) => void;
    onAddNewTicket: () => void;
    onRemoveTicket: (index: number) => void;
    heading: string[];
    title: string[];
    start_date: string[];
    start_time: string[];
    end_date: string[];
    end_time: string[];
    description: string[];
    onTitleChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onStartDateChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onStartTimeChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onEndDateChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onEndTimeChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onDescriptionChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    is_exclusive: boolean[];
    onExclusiveChange: (index: number) => void;
}

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    // Add more properties as per your item structure
}

export default function TicketGroupCode({
    items,
    ticket_group_code,
    button_name,
    url,
    onTicketGroupCodeChange,
    onButtonNameChange,
    onUrlChange,
    onAddMore,
    onDelete,
    onAddNewTicket,
    onRemoveTicket,
    heading,
    title,
    start_date,
    start_time,
    end_date,
    end_time,
    description,
    onTitleChange,
    onStartDateChange,
    onStartTimeChange,
    onEndDateChange,
    onEndTimeChange,
    onDescriptionChange,
    is_exclusive,
    onExclusiveChange
}: CommunityFormProps) {
    return (
        <>  
            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] mb-3">Content</h2>

                <Form.Group className="mb-3" controlId="formCategory">
                    <Form.Label className="text-sm mb-2">Ticket Group Code</Form.Label>
                    <Form.Select required aria-label="Select Category" className="bg-gray-200 mb-2" value={ticket_group_code} onChange={onTicketGroupCodeChange}>
                        <option value="">Select Ticket Group Code</option>
                        {items.map((item) => (
                            <option key={item.ticket_id} value={item.ticket_group_code}>
                                {item.ticket_group_code}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formCategory">
                    <Button variant="danger" onClick={onAddNewTicket}>
                        Add New Ticket Selling
                    </Button>
                </Form.Group>

                {heading.map((title, index) => (
                    <div key={index} className="mb-5 border-t pt-2">
                        <div className="flex flex-row justify-between items-center mb-2">
                            <h2 key={index} className="GraphikSemibold text-[16px] text-[#1f2328]">
                                {title}
                            </h2>

                            <Button variant="secondary" onClick={() => onRemoveTicket(index)}>
                                Remove
                            </Button>
                        </div>

                        <div className="mb-3">
                            <Form.Label className="text-sm mb-2">Title</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={(e) => onTitleChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                className="bg-gray-200 me-2"
                            />
                        </div>
                        
                        <Form.Group className="mb-3">
                            <Form.Label className="text-sm mb-2">Button and Links</Form.Label>
                            {button_name[index]?.map((btn, btnIndex) => (
                                <div key={btnIndex} className="d-flex align-items-center mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Button Name"
                                        value={button_name[index][btnIndex]}
                                        onChange={(e) => 
                                            onButtonNameChange(e as React.ChangeEvent<HTMLInputElement>, index, btnIndex)
                                        }
                                        className="bg-gray-200 me-2"
                                    />

                                    <Form.Control
                                        type="text"
                                        placeholder="Url"
                                        value={url[index][btnIndex]}
                                        onChange={(e) => 
                                            onUrlChange(e as React.ChangeEvent<HTMLInputElement>, index, btnIndex)
                                        }
                                        className="bg-gray-200 me-2"
                                    />

                                    <Button variant="secondary" onClick={() => onDelete(index, btnIndex)}>
                                        <BsTrash />
                                    </Button>
                                </div>
                            ))}
                            
                            <div>
                                <Button variant="danger" onClick={() => onAddMore(index)}>
                                    Add More
                                </Button>
                            </div>
                        </Form.Group>

                        <div className="mb-4">
                            <div className="d-flex align-items-start mb-3 gap-2">
                                <h2 key={index} className="GraphikSemibold text-[16px] text-[#1f2328]">
                                    Ticketing Schedule
                                </h2>
                            </div>

                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => onStartDateChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">Start Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        onChange={(e) => onStartTimeChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>
                            </div>

                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => onEndDateChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">End Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        onChange={(e) => onEndTimeChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>
                            </div>

                            <div className="mb-3">
                                <Form.Label className="text-sm mb-2">Description</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => onDescriptionChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                                    className="bg-gray-200"
                                />
                            </div>

                            <Form.Group className="mb-3" controlId={`formExclusive-${index}`}>
                                <Form.Check
                                    type="checkbox"
                                    label="For Logged-in Users Only"
                                    checked={is_exclusive[index] || false}
                                    onChange={() => onExclusiveChange(index)}
                                />
                            </Form.Group>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
